const setKey = () => { 
    const rand = Math.random().toString(36).substr(2);
    const dateRan = Date.now().toString(36);
    return rand + dateRan;
}

export default setKey